import React from "react";
import * as S from './styles'

import Colheita from "../../../assets/colheita-cultura.png"
import Images from "../../../assets/icons/icon-images.svg"

const CardsInformation = () => {
  return (
    <S.Container>
      <S.Card>
        <div class="texts">
          <h1>Soja</h1>
          <p>Nome científico aqui</p>
          <div>
            <h2>Safra de 8-12 semanas</h2>
            <span>US$ 50/saca</span>
          </div>
        </div>

        <div class="images">
          <img src={Colheita} alt="Imagem de uma lavroura" />
          <img src={Colheita} alt="Imagem de uma lavroura" />
          <a href=""><img src={Images} alt="ícone para ver mais imagens" /></a>
        </div>
      </S.Card>

      <S.Card>
        <div class="texts">
          <h1>Soja</h1>
          <p>Nome científico aqui</p>
          <div>
            <h2>Safra de 8-12 semanas</h2>
            <span>US$ 50/saca</span>
          </div>
        </div>

        <div class="images">
          <img src={Colheita} alt="" />
          <img src={Colheita} alt="" />
          <a href=""><img src={Images} alt="" /></a>
        </div>
      </S.Card>

    </S.Container>
  )
}

export default CardsInformation;